import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-modal-footer': {
    '.abyss-layout-group': {
      paddingTop: 'var(--abyss-space-sm)',
    },
  },
});
